import React, { useRef, useState } from "react";
import api, { API } from "../lib/apiClient";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, label, testId, height = "h-32" }) {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.file_id);
      toast.success(`${label} uploaded`);
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <p className="text-sm font-medium text-slate-700 mb-2">{label}</p>
      <div
        data-testid={testId}
        onClick={() => inputRef.current?.click()}
        className={`${height} relative cursor-pointer rounded-xl border-2 border-dashed border-slate-300 hover:border-blue-400 bg-slate-50 flex items-center justify-center overflow-hidden transition-colors`}
      >
        {uploading ? (
          <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
        ) : value ? (
          <>
            <img src={`${API}/files/${value}`} alt={label} className="max-h-full max-w-full object-contain p-2" />
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); onChange(null); }}
              className="absolute top-2 right-2 bg-white rounded-full p-1 shadow border border-slate-200"
            >
              <X className="w-4 h-4 text-slate-600" />
            </button>
          </>
        ) : (
          <div className="text-center text-slate-400">
            <Upload className="w-6 h-6 mx-auto mb-1" />
            <span className="text-xs">Click to upload</span>
          </div>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handle} />
    </div>
  );
}
